import React, { createContext, useCallback, useMemo, useState } from "react";
export const SidebarContext = createContext(null);
export const SidebarProvider = ({ children = void 0 }) => {
  const [sidebar, setSidebar] = useState();
  const clearSidebar = useCallback(() => {
    setSidebar(null);
  }, []);
  const sidebarProvider = useMemo(() => ({ sidebar, clearSidebar, setSidebar }), [sidebar, clearSidebar, setSidebar]);
  return /* @__PURE__ */ React.createElement(SidebarContext.Provider, { value: sidebarProvider }, children);
};
